export const addIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="11.25" y1="4.75" x2="11.25" y2="19.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><line x1="18.75" y1="11.75" x2="4.25" y2="11.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`,
  name: 'add' as const,
};
